<h2>File Upload</h2>
<div class="widget-container">
    <dx-file-uploader #fileUploader uploadUrl="" [multiple]="false" accept="*"
        [(value)]="value" uploadMode="useButtons"></dx-file-uploader>
    <div class="content">
        <div *ngIf="value.length > 0">
            <h4>Selected Files</h4>
        </div>
        <div *ngFor="let file of value">
            <div class="selected-item">
                Name:
                <span>{{file.name}}</span>
                <br /> Size:
                <span>{{file.size}}</span>bytes
                <br /> Type:
                <span>{{file.type}}</span>
                <br /> Last Modified Date:
                <span>{{file.lastModifiedDate}}</span>
            </div>
        </div>
    </div>
    <div class="dx-fieldset">
        <div class="dx-fieldset-header">Data import parameters</div>
        <div class="dx-field">
            <div class="dx-field-label">Product</div>
            <div class="dx-field-value">
                <dx-select-box displayExpr="Name" valueExpr="ID" [searchEnabled]="true"></dx-select-box>
            </div>
        </div>
    </div>
</div>